module.exports = __webpack_public_path__ + "img/about_member_kuroda.7adb750d.png";